/**
 * @file ToggleComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de Toggle
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-02-27
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */

"use client";
import { ToggleProps } from "@/types/ui";
import { useTranslations } from "next-intl";
import { useId } from "react";

const ToggleComponent: React.FC<ToggleProps> = ({
  id,
  name,
  checked,
  onChange,
  className,
  label,
  labelPosition = "right",
  disabled = false,
  showActivationText = true,
  ariaLabel,
}) => {
  const t = useTranslations("Labels");
  const labelId = useId();

  return (
    <article
      className={`toggle__container ${className ? className : ""} ${disabled ? "input--disabled" : ""}`}
    >
      {label && labelPosition === "left" && (
        <span id={labelId} className="toggle__label">
          {label}
        </span>
      )}

      <section className="flex__row--center--05">
        <label className="toggle">
          <input
            id={id}
            name={name}
            type="checkbox"
            checked={checked}
            onChange={() => onChange(!checked)}
            disabled={disabled}
            aria-label={ariaLabel}
            aria-labelledby={label ? labelId : undefined}
            role="switch"
          />
          <span className="toggle__slider"></span>
        </label>

        {showActivationText && (
          <span className="toggle__text">
            {checked ? t("labelActivated") : t("labelDeactivated")}
          </span>
        )}
      </section>

      {label && labelPosition === "right" && (
        <span id={labelId} className="toggle__label">
          {label}
        </span>
      )}
    </article>
  );
};

export default ToggleComponent;
